module.exports = __webpack_public_path__ + "img/Billionaire-1.13d3d4bc.gif";